import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { Assignment, Category, Country, Schema, Severity, Status, TicketRow } from '../models/tickets.models';

export const PanelStatusChanged = createAction('[Customer data: Tickets]: Panel Status Changed');

export const GetData = createAction('[Customer data: Tickets]: Get Data');

export const GetSeveritySuccess = createAction(
  '[Customer data: Tickets]: Get Severity Success',
  props<{ res: Severity[] }>(),
);

export const GetSeverityFailed = createAction(
  '[Customer data: Tickets]: Get Severity Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetLoyaltySchemaSuccess = createAction(
  '[Customer data: Tickets]: Get Loyalty Schema Success',
  props<{ res: Schema[] }>(),
);

export const GetSLoyaltySchemaFailed = createAction(
  '[Customer data: Tickets]: Get Loyalty Schema Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetStatusSuccess = createAction(
  '[Customer data: Tickets]: Get Status Success',
  props<{ res: Status[] }>(),
);

export const GetStatusFailed = createAction(
  '[Customer data: Tickets]: Get Status Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetCountriesSuccess = createAction(
  '[Customer data: Tickets]: Get Countries Success',
  props<{ res: Country[] }>(),
);

export const GetCountriesFailed = createAction(
  '[Customer data: Tickets]: Get Countries Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetCategoriesSuccess = createAction(
  '[Customer data: Tickets]: Get Categories Success',
  props<{ res: Category[] }>(),
);

export const GetCategoriesFailed = createAction(
  '[Customer data: Tickets]: Get Categories Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetAssigneesSuccess = createAction(
  '[Customer data: Tickets]: Get Assignees Success',
  props<{ res: Assignment[] }>(),
);

export const GetAssigneesFailed = createAction(
  '[Customer data: Tickets]: Get Assignees Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const TicketIDChanged = createAction(
  '[Customer data: Tickets]: Ticket ID Changed',
  props<{ ticketId: string }>(),
);

export const TicketSeverityChanged = createAction(
  '[Customer data: Tickets]: Ticket Severity Changed',
  props<{ ticketSeverity: string }>(),
);

export const TicketLSChanged = createAction(
  '[Customer data: Tickets]: Ticket LS Changed',
  props<{ loyaltySchema: string }>(),
);

export const TicketStatusChanged = createAction(
  '[Customer data: Tickets]: Ticket Status Changed',
  props<{ ticketStatus: string }>(),
);

export const TicketCountryChanged = createAction(
  '[Customer data: Tickets]: Ticket Country Changed',
  props<{ country: string }>(),
);

export const TicketCategoryChanged = createAction(
  '[Customer data: Tickets]: Ticket Category Changed',
  props<{ ticketCategory: string }>(),
);

export const TicketAssigneeChanged = createAction(
  '[Customer data: Tickets]: Ticket Assignee Changed',
  props<{ ticketAssignee: string }>(),
);

export const TicketBodyChanged = createAction(
  '[Customer data: Tickets]: Ticket Body Changed',
  props<{ body: string }>(),
);

export const TicketSubjectChanged = createAction(
  '[Customer data: Tickets]: Ticket Subject Changed',
  props<{ subject: string }>(),
);

export const ClearData = createAction('[Customer data: Tickets]: Clear Data');

export const OpenTicketNav = createAction(
  '[Customer data: Tickets]: Open Ticket Nav',
  props<{ categories: Category[]; countries: Country[]; memberColumns: string[] }>(),
);

export const GetTicketCount = createAction('[Customer data: Tickets]: Get Ticket Count');

export const GetTicketCountFailed = createAction(
  '[Customer data: Tickets]: Get Ticket Count Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const EditTicket = createAction(
  '[Customer data: Tickets]: Edit Ticket',
  props<{
    element: TicketRow;
    categories: Category[];
    countries: Country[];
    memberColumns: string[];
    statusValues: Status[];
    ticketAssigneeValues: Assignment[];
    ticketSeverityValues: Severity[];
  }>(),
);

export const CloseEditTicket = createAction('[Customer data: Tickets]: Close Edit Ticket');

export const QC_API_CREATE_TICKETSuccess = createAction('[Customer data: Tickets]: QC_API_CREATE_TICKET Success');

export const QC_API_UPDATE_TICKETSuccess = createAction('[Customer data: Tickets]: QC_API_UPDATE_TICKET Success');
